"use strict";
/* eslint-disable react/prop-types */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyTableRow = void 0;
const react_1 = __importDefault(require("react"));
const Robot_1 = __importDefault(require("../../shapes/Robot"));
const EmptyTableRow = ({ columns, message }) => (react_1.default.createElement("tr", null,
    react_1.default.createElement("td", { colSpan: columns.length, align: 'center' },
        react_1.default.createElement(Robot_1.default, { status: 'info', size: 'sm' }),
        message)));
exports.EmptyTableRow = EmptyTableRow;
